import axios from 'axios';

export const getAxiosConfig = (config = {}) => (
    { headers: { 'Content-Type': 'application/json' }, ...config }
);

export const isSpaApp = async () => {
    try {
        const { data } = await axios.get('/app/automatedSmsFunnel/isSpaApp');

        return data || false;
    } catch (e) {
        return false;
    }
};

export const getQueryString = (params) => encodeURI(Object.keys(params)
    .filter((key) => params[key] != null)
    .map((key) => `${key}=${params[key]}`)
    .reduce((acc, cur, i) => (i ? `${acc}&${cur}` : `?${cur}`), ''));

export const openSearch = async ({
    documentTypes,
    term,
    maxResults = 10,
    highlightEnabled,
}) => {
    const { data } = await axios.get('/app/search/openSearch', {
        headers: {
            Accept: 'application/json',
        },
        params: {
            documentTypes,
            term,
            maxResults,
            highlightEnabled,
        },
    });

    if (!data.success) {
        throw new Error('Error retrieving data from opensearch!');
    }

    return data.queryResponse;
};
